import { Suspense, lazy, useEffect, useState } from "react";
import slone from "../../../assets/images/group1.webp";
import slthree from "../../../assets/images/banner123.webp";
import sltwo from "../../../assets/images/sltwo2.webp";
import bannernew from "../../../assets/images/Header.png";
import cloudImage from "../../../assets/images/heaser2.png";
// import Slider from "react-slick";
import styles from "../styles/home.module.css";

import { useNavigate } from "react-router-dom";
import useAuth from "../../../lib/hooks/useAuth";
import Slider from "react-slick";
import { STRINGS } from "../../../constants/strings";
// const Slider = lazy(() => import("react-slick"));
interface HomeBannerProps {
  bannerEsim: any;
}
const HomeBanner: React.FC<HomeBannerProps> = ({ bannerEsim }) => {
  const [loader, setLoader] = useState(false);
  const [showClouds, setShowClouds] = useState(true);
  const [showText, setShowText] = useState(false);
  const bundles = Array.from({ length: 3 }, () => bannerEsim).flat();
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowClouds(false);
      // setShowImage(true);
  
      // show text slightly after image
      setTimeout(() => setShowText(true), 10);
    }, 3000);
  
    return () => clearTimeout(timer);
  }, []);
  const handleImageLoad = () => {
    setShowText(true);
  };
  // var settings = {
  //   dots: true,
  //   arrow: false,
  //   pauseOnHover: false,
  //   infinite: true,
  //   loop: true,
  //   speed: 300,
  //   fade: true,
  //   cssEase: "linear",
  //   autoplay: true,
  //   // autoplaySpeed:3000,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  // };

  return (
    <section className={styles.BannerSection }>
      {/* {loader && <MainLoader />} */}
      {/* <div className={styles.heroSection}>
      <img src={cloudImage} alt="Final Background" className={styles.bgImage} />
      <img src={bannernew} alt="Fog Overlay" className={styles.fogOverlay} />

      <div className={styles.heroText}>
        <h1 className={`${styles.textUp} ${styles.delay1}`}>
          Get Your <span className={styles.highlight}>eSIM</span>
        </h1>
        <h2 className={`${styles.textUp} ${styles.delay2}`}>in 60 Seconds</h2>
        <p className={`${styles.textUp} ${styles.delay3}`}>
          Contactless &nbsp; Instant Activation &nbsp; Fully Digital
        </p>
        <div className={`${styles.textUp} ${styles.delay4}`}>SCROLL</div>
      </div>
    </div> */}


      {/* <div className={styles.container}>
      <img src={cloudImage} alt="Background"   className={`${styles.backgroundImage} ${showText ? styles.fadeIn : ''}`}  onLoad={handleImageLoad}/>
      {showClouds && <div className={styles.cloudOverlay}></div>}
      {showText && (
  <div className={`${styles.textContainer} ${styles.textShow}`}>
    <h1>
      Get Your <span className={styles.highlight}>eSIM</span><br />
      in 60 Seconds
    </h1>
    <p>Contactless &nbsp; Instant Activation &nbsp; Fully Digital</p>
  </div>
)}
    </div> */}

<div className={styles.container}>
  {/* Background with cloud */}
  <img
    src={bannernew}
    alt="Cloudy Background"
    className={`${styles.backgroundImage} ${showText ? styles.fadeOut : ''}`}
  />

  {/* Background without cloud */}
  <img
    src={cloudImage}
    alt="Clear Background"
    className={`${styles.backgroundImage} ${showText ? styles.fadeIn : ''}`}
    onLoad={handleImageLoad}
  />

  {showText && (
    <div className={`${styles.textContainer} ${styles.textShow}`}>
      <h1>
        Get Your <span className={styles.highlight}>eSIM</span><br />
        in 60 Seconds
      </h1>
      <p>Contactless &nbsp; Instant Activation &nbsp; Fully Digital</p>
    </div>
  )}
</div>


        {/* <Suspense fallback={<div>Loading...</div>}> */}

        {/* <div className={styles.outreHomeside}>
          <img
            className={styles.bnrImage}
            width="1920"
            height="310"
            src={bannernew}
            alt="Tourism eSim"
          />
          <div className={styles.innerHomeSlide}>
            <div className="row">
              <div className="col-md-4"></div>
              <div className="col-md-8"> */}
                {/* <div className={`${styles.dotsone} ${styles.innerHomeSlideRight}`}>
                    <div className={styles.outerCirlcle}>
                      <img src={crone} alt="" />
                      <div className="bullets">
                        <span className="bulletone"></span>
                        <span className="bullettwo"></span>
                        <span className="bulletthree"></span>
                      </div>
                    </div>
                    <div className={styles.CountryInCircle}>
                      <div className={styles.topHeadFlag}>
                        <h4>{bundles[0]?.name}<img src={bundles[0]?.flagImageUrl} alt="" /></h4>
                        <ul>
                          <li>
                            <div className={styles.innerPlabs}>
                              <span>Data</span>
                              <h6>{(bundles[0]?.dataAmount)}</h6>
                            </div>
                          </li>
                          <li>
                            <div className={styles.innerPlabs}>
                              <span>Validity</span>
                              <h6>{bundles[0]?.duration} Days</h6>
                            </div>
                          </li>
                          <li>
                            <div className={styles.innerPlabs}>
                              <span>Speed</span>
                              <h6>{bundles[0]?.speed && bundles[0].speed.length > 0 ? bundles[0].speed.slice(-1) : 'Speed not Found'}</h6>
                            </div>
                          </li>
                        </ul>
                        <div className={styles.layBtn}>
                          <button aria-label="Buy Now esim" onClick={(e) => createOrder(bundles[0]._id)} >Buy Now </button>
                        </div>
                      </div>
                    </div>
                  </div> */}
              {/* </div>
            </div>
          </div>
        </div> */}
        {/* <div className={styles.outreHomeside}>
            <img
              className={styles.bnrImage}
              width="1920"
              height="310"
              src={slone}
              alt="International eSim"
              loading="lazy"
            />
            <div className={styles.innerHomeSlide}>
              <div className="row">
                <div className="col-md-4"></div>
                <div className="col-md-8">
                   <div className={`${styles.dotstwo} ${styles.innerHomeSlideRight}`}>
                    <div className={styles.outerCirlcle}>
                      <img src={crtwo} alt="" />
                      <div className="bullets">
                        <span className="bulletone"></span>
                        <span className="bullettwo"></span>
                        <span className="bulletthree"></span>
                      </div>
                    </div>
                    <div className={styles.CountryInCircle}>
                      <div className={styles.topHeadFlag}>
                        <h4>{bundles[1]?.name}<img src={bundles[1]?.flagImageUrl} alt="" /></h4>
                        <ul>
                          <li>
                            <div className={styles.innerPlabs}>
                              <span>Data</span>
                              <h6>{(bundles[1]?.dataAmount)}</h6>
                            </div>
                          </li>
                          <li>
                            <div className={styles.innerPlabs}>
                              <span>Validity</span>
                              <h6>{bundles[1]?.duration} Days</h6>
                            </div>
                          </li>
                          <li>
                            <div className={styles.innerPlabs}>
                              <span>Speed</span>
                              <h6>{bundles[1]?.speed && bundles[1].speed.length > 0 ? bundles[1].speed.slice(-1) : 'Speed not Found'}</h6>
                            </div>
                          </li>
                        </ul>
                        <div className={styles.layBtn}>
                          <button onClick={(e) => createOrder(bundles[1]._id)} >Buy Now </button>
                        </div>
                      </div>
                    </div>
                  </div> 
                  <div className={styles.afordableSim}>
                    <h4>Affordable eSIM.<br /> Global Connectivity.<br /> Unlimited Freedom.</h4>
                  </div> 
                </div>
              </div>
            </div>
          </div> */}

        {/* <div className={styles.outreHomeside}>
            <img
              width="1920"
              height="310"
              className={styles.bnrImage}
              src={sltwo}
              alt="Travel eSim"
              loading="lazy"
            />
            <div className={styles.innerHomeSlide}>
              <div className="row">
                <div className="col-md-4"></div>
                <div className="col-md-8">
                  <div className={`${styles.dotsthree} ${styles.innerHomeSlideRight}`}>
                    <div className={styles.outerCirlcle}>
                      <img src={crthree} alt="" />
                      <div className="bullets">
                        <span className="bulletone"></span>
                        <span className="bullettwo"></span>
                        <span className="bulletthree"></span>
                      </div>
                    </div>
                    <div className={styles.CountryInCircle}>
                      <div className={styles.topHeadFlag}>
                        <h4>{bundles[2]?.name}<img src={bundles[2]?.flagImageUrl} alt="" /></h4>
                        <ul>
                          <li>
                            <div className={styles.innerPlabs}>
                              <span>Data</span>
                              <h6>{(bundles[2]?.dataAmount)}</h6>
                            </div>
                          </li>
                          <li>
                            <div className={styles.innerPlabs}>
                              <span>Validity</span>
                              <h6>{bundles[2]?.duration} Days</h6>
                            </div>
                          </li>
                          <li>
                            <div className={styles.innerPlabs}>
                              <span>Speed</span>
                              <h6>{bundles[2]?.speed && bundles[2].speed.length > 0 ? bundles[2].speed.slice(-1) : 'Speed not Found'}</h6>
                            </div>
                          </li>
                        </ul>
                        <div className={styles.layBtn}>
                          <button onClick={() => createOrder(bundles[2]._id)} >Buy Now </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {<div className={styles.afordableSim}>
                    <h4>Affordable eSIM.<br /> Global Connectivity.<br /> Unlimited Freedom.</h4>
                  </div>}
                </div>
              </div>
            </div>
          </div> */}

        {/* </Suspense> */}
        {/* <div className={styles.innerHomeSlideLeft}>
          <div className="stay-new">
            <h3 className="mb-3">
              {STRINGS.TRAVEL_SMART_HEADING_LINE_1}
              <br /> {STRINGS.TRAVEL_SMART_HEADING_LINE_2}
              <br /> {STRINGS.TRAVEL_SMART_HEADING_LINE_3}
            </h3>
            <p className="py-2">
              <b>
              </b>
            </p>
            <h6>
              {STRINGS.STAY_NEW_HEADING_PART_1} <span className="mx-2">|</span>
              {STRINGS.STAY_NEW_HEADING_PART_2} <span className="mx-2">|</span>
              {STRINGS.STAY_NEW_HEADING_PART_3}
            </h6>
          </div> */}
          {/* <div className={styles.afordableSim}>
            <h4>
              {STRINGS.AFFORDABLE_SIM_LINE_1}
              <br /> {STRINGS.AFFORDABLE_SIM_LINE_2}
              <br /> {STRINGS.AFFORDABLE_SIM_LINE_3}
            </h4>
          </div> */}

          {/* <div className={styles.SimpleSearch}>
            <span><img src={srchic} alt="" /></span>
            <input type="text" placeholder="Search Destination" />
            <button>Search</button>
          </div> */}
          {/* <div className="diaCountImg">
            <img src={disc} alt="" />
          </div> */}
        {/* </div> */}
      {/* </div> */}
    </section>
  );
};

export default HomeBanner;
